module.exports = __webpack_public_path__ + "static/img/Application.38f2fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/funplus/imgs/browse/Application.jpg
// module id = 1950
// module chunks = 0